import MessageHomeDeclineService from "@services/message-home-decline-service";
import MessageHomeIntermediationService from "@services/message-home-intermediation-service";
import { initialiseComponents } from "../../core";
import Component from "../component.abstract";
import { hw } from "../helpers/paths";
import Messages from "./messages-home";

interface MessageItemProps {
  idx: string;
}

export default class MessageItem extends Component {
  private idx: number;
  private done = false;
  private data: any;
  private serviceDecline: MessageHomeDeclineService;
  private serviceIntermediation: MessageHomeIntermediationService;
  constructor(private props: MessageItemProps, element: HTMLElement) {
    super(props, element);
    this.idx = parseInt(props.idx);
  }

  mounted(): void {
    this.injectTemplate();

    PubSub.subscribe("messages.loaded", (msg: string, instance: Messages) => {
      this.populate(instance);
    });
  }
  populate(messages: Messages): void {
    if (this.done) {
      return;
    }
    const data = messages.data;
    if (data) {
      if (data.items.length > this.idx) {
        this.data = data.items[this.idx];
        const attrs = this.element.querySelectorAll("[data-attr]");
        for (let i = 0; i < attrs.length; i++) {
          let js: any = attrs[i].getAttribute("data-attr");
          try {
            js = JSON.parse(js);
          } catch (e) {
            const tmp: any = [{}];
            tmp[0].attr = "innerText";
            tmp[0].value = js;
            js = tmp;
          }
          for (let j = 0; j < js.length; j++) {
            if (this.data[js[j].value]) {
              if (js[j].attr && js[j].attr != "innerText") {
                attrs[i].setAttribute(js[j].attr, this.data[js[j].value]);
              } else {
                (<HTMLElement>attrs[i]).innerText = this.data[js[j].value];
              }
            } else {
              if (js[j].attr && js[j].attr != "innerText") {
                attrs[i].setAttribute(js[j].attr, "");
              } else {
                (<HTMLElement>attrs[i]).innerText = "";
              }
            }
          }
        }

        const span = this.element.querySelectorAll(
          "span:not(.accept):not(.refuse)"
        );
        // TODO: still usefull ? Remove if not
        if (this.data.message) {
          span[0].innerHTML = this.data.message;
        }
        if (this.data.secondMessage) {
          span[1].innerHTML = this.data.secondMessage;
        }
        const buttons = this.element.querySelectorAll("div.buttons>a");
        const firstButton: HTMLElement = <HTMLElement> buttons[0];
        const decline = this.element.querySelectorAll("div.buttons > span")[0];
        decline.setAttribute("data-item", this.idx.toString());
        switch (this.data.type) {
          case 1:
            this.element.classList.add("recruteurMsg");
            span[0].innerHTML =
              "La société " + this.data.companyName + " a consulté votre CV";
            
            if (this.data.buttonLink) {
              firstButton.innerHTML = "Voir les offres de l'entreprise";
              firstButton.classList.add("asButton");
            } else {
              firstButton.style.display = "none";
            }
            
            this.element.querySelector<HTMLElement>(
              "div.buttons+span"
            ).style.display = "none";
            (<HTMLElement>decline).style.display = "none";
            break;
          case 2:
            this.element.classList.add("intermediation");
            firstButton.innerHTML = "Oui, je me positionne";
            firstButton.classList.add("intermediation", "asButton");
            firstButton.removeAttribute("href");
            firstButton.setAttribute("data-l", this.data.buttonLink);
            this.element.querySelector<HTMLElement>(
              "div.buttons+span"
            ).innerText += " " + this.data.companyName;

            if (this.data.secondButtonLink) {
              const link = this.element.querySelector(".wrapper > div > a");
              link.innerHTML = "En savoir + sur l’entreprise";
              link.setAttribute("href", this.data.secondButtonLink);
              link.setAttribute("target", "_blank");
            }
            this.serviceDecline = new MessageHomeDeclineService(
              this.data.buttonLink + "&accept=false"
            );

            decline.addEventListener("click", (event) => {
              const slide = event.target;
              this.serviceDecline.post("", this.deleteSlide(<HTMLElement>slide));
            });
            break;
        }

         // Add GA click events
        if (this.data.trackingsClick && this.data.trackingsClick.length) {
          firstButton.setAttribute("data-track", JSON.stringify(this.data.trackingsClick[0]));

            if (this.data.trackingsClick.length > 1) {
                decline.setAttribute("data-track", JSON.stringify(this.data.trackingsClick[1]));
            }
        }

        const images = this.element.querySelectorAll("img");
        for (let k = 0; k < images.length; k++) {
          if (images[k].getAttribute("src") != "") {
            images[k].classList.remove("hidden");
          }
        }

        const radio = this.element.querySelector("input[type=radio]");
        radio.setAttribute("id", "swipe_1_" + this.idx);
        if (this.idx === 0) {
           radio.setAttribute("checked", "checked");
        }

        const next = this.element.querySelector("label.next");
        next.setAttribute("data-for", "swipe_1_" + (this.idx + 1));
        next.innerHTML = this.idx + 1 + "/" + data.count;
        if (this.idx === data.count - 1) {
          next.classList.add("no-before");
        } else {
          const eventtracking = data.items[this.idx + 1].trackingsLoad[0];
          if (eventtracking) {
            eventtracking.trigger = "clic";
            next.setAttribute("data-track", JSON.stringify(eventtracking));
          }
        }

        if (this.element.querySelector(".intermediation")){
                    this.element.querySelector(".intermediation").addEventListener("click", () => {
                       const url = this.element.querySelector(".accept").getAttribute("data-l") + "&accept=true";
                        this.serviceIntermediation =
                          new MessageHomeIntermediationService(url);
                        this.serviceIntermediation.post("", this.handleResponse.bind(this));                      
                    });
          }

        initialiseComponents();

        const previous = this.element.querySelector("label.previous");
        if (this.idx > 0) {
          previous.setAttribute("data-for", "swipe_1_" + (this.idx - 1));
          const event = data.items[this.idx - 1].trackingsLoad[0];
          if (event) {
            event.trigger = "clic";
            previous.setAttribute("data-track", JSON.stringify(event));
          }
        } else {
          // In case of first message, it will be displayed on page load, so add a load event
          if (this.data.trackingsLoad && this.data.trackingsLoad.length) {
            const eventtracking = this.data.trackingsLoad[0];
            eventtracking.trigger = "init";
            this.element.setAttribute("data-track", JSON.stringify(eventtracking));
          }

          (<HTMLElement>previous).style.display = "none";
        }
      }
      this.done = true;
    }
  }
  deleteSlide(slide: HTMLElement):void {
        const itemClck = parseInt(slide.getAttribute("data-item"));
        const items = document.querySelectorAll("input[name=swipe_1");
        //Si on supprime la dernière slide on affiche la slide précédente
        if(!document.querySelector("#swipe_1_" + (itemClck + 1)) && document.querySelector("#swipe_1_" + (itemClck - 1))){
            document.querySelector<HTMLInputElement>("#swipe_1_" + (itemClck - 1)).checked = true;
        }

        //A partir de la slide supprimé on copie la suivante dans la précédente et on supprime la dernière
        for(let j = 0; j < items.length; j++){
            if(j >= itemClck && j < items.length - 1){
                document.querySelector("#swipe_1_" + j + "+div.wrapper").innerHTML = document.querySelector("#swipe_1_" + (j + 1) + "+div.wrapper").innerHTML;
                document.querySelector("#swipe_1_" + j + "+div.wrapper>label.previous").setAttribute("for", "swipe_1_" + (j - 1));
                if(document.querySelector("#swipe_1_" + j + "+div.wrapper span.refuse")){
                    document.querySelector("#swipe_1_" + j + "+div.wrapper span.refuse").setAttribute("data-item", j.toString());
                    document.querySelector("#swipe_1_" + j + "+div.wrapper span.refuse").addEventListener("click", (event) => {
                        this.deleteSlide(<HTMLElement>event.target);
                    });
                }
                document.querySelector("#swipe_1_" + j + "+div.wrapper>label.next").setAttribute("for", "swipe_1_" + (j + 1));
            }
            if(j == items.length - 1){
                document.querySelector("#swipe_1_" + j + "+div.wrapper").remove();
                items[j].remove();
                if(j != 0){
                    document.querySelector<HTMLElement>("#swipe_1_" + (j - 1)  + "+div.wrapper>label.next").style.display = "none";
                    document.querySelector("#swipe_1_" + (j - 1)  + "+div.wrapper>label.previous").innerHTML = document.querySelector("#swipe_1_" + (j - 1)  + "+div.wrapper>label.next").innerHTML;
                }
            }
            if(j == 0 && document.querySelector("#swipe_1_" + j + "+div.wrapper>label.previous")){
                document.querySelector<HTMLElement>("#swipe_1_" + j + "+div.wrapper>label.previous").style.display = "none";
            }
        }
        //Si il n'y a plus de slide on supprime la gallery
        if(document.querySelectorAll("input[name=swipe_1").length === 0){
            document.querySelector("section[data-gallery-swipe]").remove();
        }
        //On met à jour les id pour les input hidden
        for(let j =0; j < items.length - 1; j++){
            const max = document.querySelector("#swipe_1_" + j + "+div.wrapper>label.next").innerHTML.split("/");
            const maximum = parseInt(max[1]);
            items[j].setAttribute("id", "swipe_1_"+j);
            document.querySelector("#swipe_1_" + j + "+div.wrapper>label.next").innerHTML = (j + 1) + "/" + (maximum - 1);
            if(j == items.length - 2){
                document.querySelector("#swipe_1_" + j + "+div.wrapper>label.previous").innerHTML = (j + 1) + "/" + (maximum - 1);
            }
        }
  }
  handleResponse(response:any):void {
      const spans = this.element.getElementsByTagName("span");
      if (response.success === true) {
          spans[0].innerHTML ="<svg data-load-url= '" + hw.getBaseRessourcesUrl() + "/img/svg/check.svg' class='check' /> Votre intérêt pour le poste a été transmis à " +
          this.data.companyName;
          spans[1].innerHTML = "qui va étudier votre profil";
      } else {
          spans[0].innerHTML = "Aïe, une erreur est survenue, rechargez la page et réessayez.";
          spans[1].innerHTML = "";
          this.element.querySelector(".buttons").nextElementSibling.innerHTML = "";
      }
      this.element.querySelector(".buttons").innerHTML = "";
      initialiseComponents();
  }
}
